var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAnnouncementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "announcement-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.5 10.9999H13.6C10.2397 10.9999 8.55952 10.9999 7.27605 11.6539C6.14708 12.2291 5.2292 13.147 4.65396 14.276C4 15.5595 4 17.2396 4 20.6L4 22.9999C4 24.8637 4 25.7956 4.30449 26.5307C4.71046 27.5108 5.48916 28.2895 6.46927 28.6955C7.20435 28.9999 8.13624 28.9999 10 28.9999V37.4999C10 37.9643 10 38.1965 10.0193 38.392C10.2063 40.2911 11.7088 41.7936 13.6079 41.9807C13.8035 41.9999 14.0357 41.9999 14.5 41.9999C14.9643 41.9999 15.1965 41.9999 15.3921 41.9807C17.2912 41.7936 18.7937 40.2911 18.9807 38.392C19 38.1965 19 37.9643 19 37.4999V28.9999H20.5C24.0329 28.9999 28.3545 30.8937 31.6886 32.7112C33.6337 33.7715 34.6062 34.3017 35.2431 34.2237C35.8338 34.1513 36.2804 33.8861 36.6266 33.4022C37 32.8802 37 31.836 37 29.7474V10.2525C37 8.16394 37 7.11965 36.6266 6.59772C36.2804 6.11375 35.8338 5.84855 35.2431 5.7762C34.6062 5.69819 33.6337 6.22834 31.6886 7.28865C28.3545 9.10617 24.0329 10.9999 20.5 10.9999Z",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    opacity: 0.3,
    d: "M44 16V24",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncementIcon);
export default __webpack_public_path__ + "static/media/ic-announcement-icon.abdedd05c1c58253af217635a627e82e.svg";
export { ForwardRef as ReactComponent };